import globalSite from '../api/globalSite'
import statement from '../api/statement'
import { setCookie } from '../utils/cookie'
import { MessageBox } from 'element-ui'

const actions = {
  // 获取认证token
  getToken ({ commit, dispatch }, payload) {
    const { token, router } = payload;
    return globalSite.getToken({ token })
      .then(response => {
        if (response.status === 200) {
          const { data } = response;
          setCookie('cookieToken', `JWT ${data.token}`, 1);
          dispatch('getProfile', {router});
          router.push('/dashboard');
          if (data.first) {
            MessageBox({
              title: '短信服务开通成功',
              message: '系统将免费赠送 50 条短信，供您测试使用！',
              customClass: 'messagebox-customed',
              showConfirmButton: false
            });
          }
        } else {
          setTimeout(() => {
            if (process.env.NODE_ENV === 'development') {
              window.location.href = 'http://franky.upyun.com:7001/accounts/signout/';
            } else {
              window.location.href = 'https://console.upyun.com/accounts/signout/';
            }
          }, 1000);
        }
      });
  },
  // 获取用户信息
  getProfile ({ commit, dispatch }, payload) {
    const { router } = payload;
    return new Promise((resolve, reject) => {
      globalSite.getProfile().then(response => {
        if (response.status === 200) {
          const { data } = response;
          commit('UPDATE_GLOBAL_PROFILE', {
            profile: data,
            remain: data.remain,
            isPost: data.isPost,
            subscription: data.subscription
          });
          statement.getCmppAccounts().then(({ data }) => { // 存储用户信息
            const role = JSON.parse(window.sessionStorage.getItem('role')) // [] 仍执行
            if (role) {
              console.log('action');
            } else {
              // 初始不存在，存储
              dispatch('permission/generateRoutes', data.cmpp_accounts.length > 0 ? ['cmpp'] : ['http']).then((accessRoutes) => {
                router.addRoutes(accessRoutes)
                window.sessionStorage.setItem('role', JSON.stringify(data.cmpp_accounts)) // 存储用户cmpp账户信息
              })
            }
            resolve(data)
          })
        }
      });
    })
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js